import { render, staticRenderFns } from "./AssetChangeTiles.vue?vue&type=template&id=52a04546&scoped=true"
import script from "./AssetChangeTiles.vue?vue&type=script&lang=js"
export * from "./AssetChangeTiles.vue?vue&type=script&lang=js"
import style0 from "./AssetChangeTiles.vue?vue&type=style&index=0&id=52a04546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a04546",
  null
  
)

export default component.exports